<template>
  <div class="keypad">
      <div class="card bg-secondary shadow border-0" style="max-width: 600px;">
          <div class="card-header bg-white">
              <div class="display">
                  <div v-if="busy"><div class="loader-black" style="font-size: 8px;">Loading...</div></div>
                  <div v-else-if="message" class="message" :class="['text-' + message_type ]">{{ message }}</div>
                  <div v-else class="code"><div class="star" v-for="(char, idx) in input" :key="'star-' + idx">{{ $parent.debug ? char : '*' }}</div></div>
              </div>
          </div>
          <div class="card-body">
              <div class="button-grid">
                  <div><button type="button" class="btn btn-white rounded-circle" v-touch:start="tapInput('1')" v-touch-options="{ touchClass: 'active' }" :disabled="busy">1</button></div>
                  <div><button type="button" class="btn btn-white rounded-circle" v-touch:start="tapInput('2')" v-touch-options="{ touchClass: 'active' }" :disabled="busy">2</button></div>
                  <div><button type="button" class="btn btn-white rounded-circle" v-touch:start="tapInput('3')" v-touch-options="{ touchClass: 'active' }" :disabled="busy">3</button></div>

                  <div><button type="button" class="btn btn-white rounded-circle" v-touch:start="tapInput('4')" v-touch-options="{ touchClass: 'active' }" :disabled="busy">4</button></div>
                  <div><button type="button" class="btn btn-white rounded-circle" v-touch:start="tapInput('5')" v-touch-options="{ touchClass: 'active' }" :disabled="busy">5</button></div>
                  <div><button type="button" class="btn btn-white rounded-circle" v-touch:start="tapInput('6')" v-touch-options="{ touchClass: 'active' }" :disabled="busy">6</button></div>

                  <div><button type="button" class="btn btn-white rounded-circle" v-touch:start="tapInput('7')" v-touch-options="{ touchClass: 'active' }" :disabled="busy">7</button></div>
                  <div><button type="button" class="btn btn-white rounded-circle" v-touch:start="tapInput('8')" v-touch-options="{ touchClass: 'active' }" :disabled="busy">8</button></div>
                  <div><button type="button" class="btn btn-white rounded-circle" v-touch:start="tapInput('9')" v-touch-options="{ touchClass: 'active' }" :disabled="busy">9</button></div>

                  <div><button type="button" class="btn btn-white rounded-circle" v-touch:start="btnDelete" v-touch-options="{ touchClass: 'active' }" :disabled="busy">DEL</button></div>
                  <div><button type="button" class="btn btn-white rounded-circle" v-touch:start="tapInput('0')" v-touch-options="{ touchClass: 'active' }" :disabled="busy">0</button></div>
                  <div><button type="button" class="btn btn-white rounded-circle" v-touch:start="btnSubmit" v-touch-options="{ touchClass: 'active' }" :disabled="busy">OK</button></div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    name: 'Keypad',
    props: {
        busy: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        input: '',
        message: '',
        message_type: 'default',
    }),
    created() {
        window.addEventListener('keydown', this.keyPress);
    },
    destroyed() {
        window.removeEventListener('keydown', this.keyPress);
    },
    methods: {
        btnInput(input) {
            if (!this.busy) {
                this.clearMessage();
                this.input += input;
            }
        },
        tapInput(input) {
            return (direction, event) => {
                this.btnInput(input)
            }
        },
        btnDelete() {
            if (!this.busy) {
                this.clearMessage();
                this.$emit('clear', this.input);
                this.clear();
            }
        },
        btnSubmit() {
            if (!this.busy) {
                this.$emit('input', this.input);
                this.clear();
            }
        },
        clear() {
            if (!this.busy) {
                this.input = '';
            }
        },
        showMessage(message, type = 'default') {
            this.message = message;
            if (type === 'danger' || type === 'info' || type === 'success') {
                this.message_type = type;
            }
            return new Promise((resolve) => {
                setTimeout(() => {
                    this.clearMessage();
                    resolve();
                }, 2000);
            })
        },
        clearMessage() {
            this.message = '';
            this.message_type = 'default';
        },
        keyPress(e) {
            let cmd = e.code;
            switch (cmd) {
                case 'Numpad0':
                case 'Digit0':
                    this.btnInput(0);
                    break;
                case 'Numpad1':
                case 'Digit1':
                    this.btnInput(1);
                    break;
                case 'Numpad2':
                case 'Digit2':
                    this.btnInput(2);
                    break;
                case 'Numpad3':
                case 'Digit3':
                    this.btnInput(3);
                    break;
                case 'Numpad4':
                case 'Digit4':
                    this.btnInput(4);
                    break;
                case 'Numpad5':
                case 'Digit5':
                    this.btnInput(5);
                    break;
                case 'Numpad6':
                case 'Digit6':
                    this.btnInput(6);
                    break;
                case 'Numpad7':
                case 'Digit7':
                    this.btnInput(7);
                    break;
                case 'Numpad8':
                case 'Digit8':
                    this.btnInput(8);
                    break;
                case 'Numpad9':
                case 'Digit9':
                    this.btnInput(9);
                    break;
                case 'NumpadEnter':
                case 'Enter':
                    this.btnSubmit();
                    break;
                case 'Backspace':
                case 'Delete':
                    this.btnDelete();
                    break;
            }
        }
    }
}
</script>

<style scoped>
.display {
    width: 100%;
    text-align: center;
    height: 65px;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.display .code .star {
    height: 100%;
    padding: 0 1px 0 1px;
    display: inline-block;
    font-size: 30px;
    font-weight: Bold;
}
.display .message {
    font-size: 18px;
    font-weight: Bold;
}
.button-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr 1fr;
    grid-column-gap: 10px;
    grid-row-gap: 10px;
}
.button-grid div {
    position: relative;
}
.button-grid div:before {
    content: '';
    display: block;
    padding-top: 100%;
}
.button-grid div button {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    padding: 10px;
    font-size: 1.5rem;
}
</style>
